module.exports = __webpack_public_path__ + "cc749eccd3bb1c74dd4e6e4b0884ada2.glb";